import React, { useEffect, useState } from "react";
import api, { RESEARCH_CATEGORIES, fileUrl } from "@/lib/api";
import { PageHeader, EmptyState } from "@/components/Layout";
import { Button } from "@/components/ui/button";
import { PdfViewerModal } from "@/components/PdfViewerModal";
import { FileText, Download, BookOpen, User, Calendar } from "lucide-react";

const ResearchItem = ({ item }) => {
  const [open, setOpen] = useState(false);
  return (
    <>
      <div data-testid={`research-card-${item.id}`} className="bg-white border border-amber-200/60 rounded-xl p-6 shadow-sm card-hover flex flex-col sm:flex-row gap-5">
        <div className="w-14 h-14 rounded-lg bg-[#0a2540] text-amber-400 flex items-center justify-center shrink-0">
          <FileText size={26} />
        </div>
        <div className="flex-1">
          <span className="text-xs bg-amber-50 text-amber-700 px-2.5 py-1 rounded-full">{item.category}</span>
          <h3 className="font-serif-deva text-xl text-[#0a2540] mt-2">{item.title}</h3>
          <div className="flex flex-wrap gap-4 text-sm text-slate-500 mt-2">
            {item.author && <span className="flex items-center gap-1"><User size={13} /> {item.author}</span>}
            {item.year && <span className="flex items-center gap-1"><Calendar size={13} /> {item.year}</span>}
          </div>
          {item.description && <p className="text-slate-600 mt-3">{item.description}</p>}
          {item.pdf_url && (
            <div className="flex gap-2 mt-4">
              <Button size="sm" onClick={() => setOpen(true)} data-testid={`research-read-${item.id}`} className="bg-[#0a2540] hover:bg-[#061729] gap-1">
                <BookOpen size={15} /> पढ़ें
              </Button>
              <a href={fileUrl(item.pdf_url, true)} target="_blank" rel="noopener noreferrer" data-testid={`research-download-${item.id}`}>
                <Button size="sm" variant="outline" className="border-amber-400 text-amber-700 hover:bg-amber-50 gap-1">
                  <Download size={15} /> डाउनलोड
                </Button>
              </a>
            </div>
          )}
        </div>
      </div>
      <PdfViewerModal open={open} onOpenChange={setOpen} url={item.pdf_url} title={item.title} />
    </>
  );
};

export default function Research() {
  const [items, setItems] = useState([]);
  const [cat, setCat] = useState("सभी");
  const [loading, setLoading] = useState(true);

  useEffect(() => {
    window.scrollTo(0, 0);
    api.get("/research").then((res) => setItems(res.data)).catch(() => {}).finally(() => setLoading(false));
  }, []);

  const filtered = cat === "सभी" ? items : items.filter((i) => i.category === cat);

  return (
    <div>
      <PageHeader testId="research-header" title="शोध एवं प्रकाशन" subtitle="शोध पत्र, रिपोर्ट, प्रकाशन एवं महत्वपूर्ण दस्तावेज़" />
      <section className="max-w-5xl mx-auto px-4 sm:px-6 py-14">
        <div className="flex gap-2 flex-wrap mb-8">
          {["सभी", ...RESEARCH_CATEGORIES].map((c) => (
            <button key={c} data-testid={`research-cat-${c}`} onClick={() => setCat(c)}
              className={`px-4 py-2 rounded-full text-sm font-medium transition-colors ${
                cat === c ? "bg-[#0a2540] text-white" : "bg-white border border-amber-200 text-[#0a2540] hover:bg-amber-50"
              }`}>{c}</button>
          ))}
        </div>

        {loading ? (
          <div className="text-center py-20 text-slate-400">लोड हो रहा है...</div>
        ) : filtered.length > 0 ? (
          <div className="space-y-5">
            {filtered.map((i) => <ResearchItem key={i.id} item={i} />)}
          </div>
        ) : (
          <EmptyState icon="file-lines" message={items.length ? "कोई प्रकाशन नहीं मिला।" : "अभी तक कोई शोध या प्रकाशन नहीं जोड़ा गया है।"} />
        )}
      </section>
    </div>
  );
}
